module.exports = __webpack_public_path__ + "static/media/star-rating-high-performer.9e7d1757.svg";